const ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

const TILES = {
  voyager:
    "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
};

function getCartoKey() {
  const el = document.querySelector("#basemapConfig");
  if (!el) return "";
  try {
    return JSON.parse(el.textContent).carto_key || "";
  } catch (e) {
    return "";
  }
}

export function tileUrl(style = "voyager", key = getCartoKey()) {
  return key ? `${TILES[style]}?key=${encodeURIComponent(key)}` : TILES[style];
}

export function addBaseLayer(map, L, style = "voyager") {
  return L.tileLayer(tileUrl(style), {
    attribution: ATTRIBUTION,
    subdomains: "abcd",
    maxZoom: 20,
  }).addTo(map);
}
